"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SNETSignupConfirmModule = _interopRequireDefault(require("./SNETSignupConfirm.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Info = props => {
  const {
    title,
    description
  } = props;
  return /*#__PURE__*/_react.default.createElement("p", {
    className: _SNETSignupConfirmModule.default.signupconfirmDetail
  }, /*#__PURE__*/_react.default.createElement("span", null, title), description);
};
Info.propTypes = {
  title: _propTypes.default.string,
  description: _propTypes.default.string
};
var _default = exports.default = Info;